import { type UseQueryResult, useQuery } from 'react-query';
import {
  StatusDropdownAppServicesService,
  Wealthlane_AwardService_Dtos_Common_PoolDropdownForAwardDto,
} from '@wealthlane/api-services/wealthlane-award-service';

const useGetPlanGrantPoolIdList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  Wealthlane_AwardService_Dtos_Common_PoolDropdownForAwardDto[] | undefined,
  unknown
> => {
  const planGrantPoolIdList = useQuery(['getPlanGrantPoolIdList'], async () => {
    return await handleRequest(
      StatusDropdownAppServicesService.getApiAwardApiAppStatusDropdownAppServicesPlansWithPoolForDropdown()
    );
  });

  return planGrantPoolIdList;
};

export default useGetPlanGrantPoolIdList;
